import React, { Component } from 'react';
import Modal from 'react-modal';

import { Link } from 'gatsby';

import config from '../../config';
import './Layout';

class About extends Component {
    constructor(props){
        super(props)
        this.state = {
          isModalOpen: false,
        }
    }
    handleModalOpen = event => {
      // console.log('handleModalOpen: ', event);
      this.setState({ isModalOpen: true })
    }
  
    handleModalClose = event => {
      // console.log('handleModalOpen: ', event);
      this.setState({ isModalOpen: false })
    }

    render(){
        return(
            <div className="w-100">
              <h1 className="mb-0">
                {config.firstName}
                <span className="text-primary">{config.lastName}</span>
              </h1>
              <div className="subheading mb-5">
                {config.address} · {config.phone} ·
                <a href={`mailto:${config.email}`}>{config.email}</a>
              </div>
              <p className="lead mb-5">
                Hey there! I'm a Melbourne based game designer and programmer with a smattering of Python automation, AWS cloud and sys admin skills thrown in for good measure.
              </p>
              <div className="social-icons">
                {config.socialLinks.map(social => {
                  const { icon, url } = social;
                  return (
                    <a key={url} href={url} target="_blank" rel="noopener noreferrer">
                      <i className={`fab ${icon}`}></i>
                    </a>
                  );
                })}
              <Link to="#" onClick={() => {this.handleModalOpen();}}>
                <i className={`fab far fa-file-alt`}></i>
              </Link>
              <Modal 
                isOpen = {this.state.isModalOpen}
                className = "Modal"
                onRequestClose = {this.handleModalClose}
                contentLabel = "Resume"
              >
                <div className = 'resumeModal'>
                  <h2>Resume</h2>
                  <embed src={config.resumeLink} frameborder="0" width="100%" height="600px" />
                  <button onClick={this.handleModalClose}>Close</button>
                </div>
              </Modal>
            </div>
          </div>
        );

    }
}

export default About;